(function (halifaxThemeImageGallery, Drupal, $) {
  Drupal.behaviors.halifaxThemeImageGallery = {
    attach: function (context) {
      // Attach the form submit only once.
      const imageGallery = once('imageGallery', '.c-image-gallery', context);
      const imageGalleryIDs = [];
      imageGallery.forEach(function (el) {
        imageGalleryIDs.push($(el).attr('id'));
      });
      imageGalleryIDs.forEach(function (ID) {
        $(`#${ID}  .c-image-gallery__thumbs`).slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          asNavFor: `#${ID} .c-image-gallery__display-image`,
          swipeToSlide: true,
          focusOnSelect: true,
          responsive: [
            {
              breakpoint: 640,
              settings: {
                arrows: false,
                infinite: false,
              },
            },
          ],
          zIndex: 1,
        });
        $(`#${ID} .c-image-gallery__display-image`).slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
          asNavFor: `#${ID}  .c-image-gallery__thumbs`,
          zIndex: 1,
        });
      });
    },
  };
})(
  (window.halifaxThemeImageGallery = window.halifaxThemeImageGallery || {}),
  Drupal,
  jQuery
);
